const NeedHelpIcon = () => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clipPath="url(#clip0_589_11673)">
          <path
            d="M12 0C5.37281 0 0 5.37234 0 12C0 18.6277 5.37281 24 12 24C18.6272 24 24 18.6272 24 12C24 5.37281 18.6277 0 12 0Z"
            fill="#0070F0"
          />
          <path
            d="M5.65126 18.7885C12.8527 18.7885 18.6905 12.9506 18.6905 5.7497C18.6916 4.34543 18.4656 2.95022 18.0211 1.61814C16.1927 0.555257 14.1149 -0.00313937 12 1.32759e-05C5.37282 1.32759e-05 1.34403e-05 5.37283 1.34403e-05 12C-0.00325469 14.1789 0.589543 16.3171 1.71423 18.1833C2.98783 18.5855 4.31567 18.7896 5.65126 18.7885Z"
            fill="#0070F0"
          />
          <path
            d="M13.3256 19.1422C13.2945 19.2882 13.2218 19.4221 13.1162 19.5277C13.0107 19.6333 12.8768 19.706 12.7308 19.737C12.2465 19.812 11.7535 19.812 11.2692 19.737C11.1232 19.706 10.9893 19.6333 10.8837 19.5277C10.7781 19.4221 10.7054 19.2882 10.6743 19.1422C10.6 18.658 10.6 18.1653 10.6743 17.6811C10.7056 17.5351 10.7783 17.4013 10.8839 17.2958C10.9894 17.1902 11.1232 17.1175 11.2692 17.0863C11.7535 17.0119 12.2464 17.0119 12.7308 17.0863C12.8767 17.1175 13.0105 17.1902 13.1161 17.2958C13.2216 17.4013 13.2944 17.5351 13.3256 17.6811C13.4 18.1653 13.4 18.658 13.3256 19.1422ZM14.6911 12.3308C13.4104 13.1206 13.0898 13.5266 13.0898 14.3164V14.5597C13.0896 14.8879 12.959 15.2025 12.7269 15.4345C12.4948 15.6664 12.18 15.7967 11.8518 15.7967C11.5234 15.7967 11.2084 15.6662 10.9761 15.434C10.7439 15.2017 10.6134 14.8867 10.6134 14.5583V13.9958C10.6134 12.6931 11.2326 11.818 12.7059 10.9428C14.159 10.0887 14.6278 9.51219 14.6278 8.63703C14.6278 7.61234 13.7737 6.94953 12.5142 6.94953C11.1548 6.94953 10.2811 7.59969 9.90653 8.78094C9.81385 9.06656 9.62787 9.31275 9.37845 9.47997C9.12903 9.64718 8.83064 9.72572 8.53122 9.70297C7.66544 9.64016 7.0781 8.78469 7.342 7.95828C8.01888 5.84516 9.91169 4.49609 12.5156 4.49609C15.1842 4.49609 17.2968 6.22531 17.2968 8.59484C17.2968 10.1534 16.5061 11.2208 14.6911 12.3308Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_589_11673">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
  );
};
export default NeedHelpIcon;
